import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import Router from 'vue-router';
import store from '../store';
import HomePage from '../pages/HomePage.vue';
import ForgotPassword from '../pages/account/ForgotPassword.vue';
import ChangePassword from '../pages/account/ChangePassword.vue';
import CreatePassword from '../pages/account/CreatePassword.vue';
import Account from '../pages/account/Account.vue';
import RequestACard from '../pages/account/RequestACard.vue';
import Statements from '../pages/account/Statements.vue';
import Claims from '../pages/account/Claims.vue';
import LookupQuotes from '../pages/account/LookupQuotes.vue';
import ReceiveAQuote from '../pages/ReceiveAQuote.vue';
import Connect from '../pages/Connect.vue';
import Rollover from '../pages/Rollover.vue';
import Unavailable from '../pages/Unavailable.vue';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy.vue';
import TermsOfUse from '../pages/legal/TermsOfUse.vue';
import PageNotFound from '../pages/PageNotFound.vue';
import MyPolicy from '@/pages/MyPolicy';
import Documents from '@/pages/Documents';
import Sms from '@/pages/legal/Sms';
import Faq from '@/pages/Faq';
import ContactUs from '@/pages/ContactUs';
import StayConnected from '@/pages/Subscribe.vue';

Vue.use(VueScrollTo);
Vue.use(Router);

// routes whose urls carry tokens/PII; keep out of search indexes
const NOINDEX = { name: 'robots', content: 'noindex, nofollow' };

const router = new Router({
  linkActiveClass: '',
  linkExactActiveClass: 'is-active',
  mode: 'history',

  description:
    'You know what to expect from your Porsche. Why expect anything less from your auto insurance? Receive your Porsche Auto Insurance quote today.',
  routes: [
    {
      name: 'HomePage',
      path: '/',
      component: HomePage,
      meta: {
        title: 'Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'You know what to expect from your Porsche. Why expect anything less from your auto insurance? Receive your Porsche Auto Insurance quote today.'
          },
          {
            property: 'og:description',
            content:
              'You know what to expect from your Porsche. Why expect anything less from your auto insurance? Receive your Porsche Auto Insurance quote today.'
          }
        ]
      }
    },
    {
      name: 'HomePage',
      path: '/search-for-my-quote',
      component: HomePage,
      meta: {
        title: 'Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'You know what to expect from your Porsche. Why expect anything less from your auto insurance? Receive your Porsche Auto Insurance quote today.'
          },
          {
            property: 'og:description',
            content:
              'You know what to expect from your Porsche. Why expect anything less from your auto insurance? Receive your Porsche Auto Insurance quote today.'
          }
        ]
      }
    },
    {
      name: 'Account',
      path: '/account',
      component: Account,
      meta: {
        requiresAuth: true,
        title: 'Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'View your vehicles, coverages, and drivers in your Account page.'
          },
          {
            property: 'og:description',
            content:
              'View your vehicles, coverages, and drivers in your Account page.'
          }
        ]
      }
    },
    {
      name: 'ForgotPassword',
      path: '/account/forgot-password',
      component: ForgotPassword,
      meta: {
        suppressMainNavigation: true,
        title: 'Forgot Password - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Reset your Porsche Auto Insurance password'
          },
          {
            property: 'og:description',
            content: 'Reset your Porsche Auto Insurance password'
          }
        ]
      }
    },
    {
      name: 'ChangePassword',
      path: '/account/change-password',
      component: ChangePassword,
      meta: {
        requiresAuth: true,
        suppressMainNavigation: true,
        title: 'Change Password - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Change your account password'
          },
          {
            property: 'og:description',
            content: 'Change your account password'
          }
        ]
      }
    },
    {
      name: 'CreatePassword',
      path: '/account/create-password',
      component: CreatePassword,
      meta: {
        requiresAuth: false,
        suppressMainNavigation: true,
        title: 'Create Password - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'Create a password to access your Porsche Auto Insurance policy online'
          },
          {
            property: 'og:description',
            content:
              'Create a password to access your Porsche Auto Insurance policy online'
          },
          NOINDEX
        ]
      }
    },
    {
      name: 'RequestACard',
      path: '/account/request-a-card',
      component: RequestACard,
      meta: {
        requiresAuth: true,
        title: 'Request a Card - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Request a new Porsche Auto Insurance card'
          },
          {
            property: 'og:description',
            content: 'Request a new Porsche Auto Insurance card'
          }
        ]
      }
    },
    {
      name: 'Statements',
      path: '/account/Statements',
      component: Statements,
      meta: {
        requiresAuth: true,
        title: 'Statements - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Here is your Porsche Auto Insurance statement'
          },
          {
            property: 'og:description',
            content: 'Here is your Porsche Auto Insurance statement'
          }
        ]
      }
    },
    {
      name: 'Claims',
      path: '/account/claims',
      component: Claims,
      meta: {
        requiresAuth: false,
        title: 'Claims - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'View information on filing a claim with Porsche Auto Insurance'
          },
          {
            property: 'og:description',
            content:
              'View information on filing a claim with Porsche Auto Insurance'
          }
        ]
      }
    },
    {
      name: 'MyPolicy',
      path: '/account/my-policy',
      component: MyPolicy,
      meta: {
        requiresAuth: false,
        title: 'My Policies - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Retrieve your policy documents.'
          },
          {
            property: 'og:description',
            content: 'Retrieve your policy documents.'
          }
        ]
      }
    },
    {
      name: 'Documents',
      path: '/account/documents/:id',
      component: Documents,
      props: route => ({
        token: route.params.id
      }),
      meta: {
        requiresAuth: false,
        title: 'My Documents - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Retrieve your policy documents.'
          },
          {
            property: 'og:description',
            content: 'Retrieve your policy documents.'
          },
          NOINDEX
        ]
      }
    },
    {
      name: 'LookupQuotes',
      path: '/account/lookup-quotes',
      component: LookupQuotes,
      meta: {
        requiresAuth: true,
        title: 'Lookup Quotes - Account - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Enter your information to retrieve an existing quote'
          },
          {
            property: 'og:description',
            content: 'Enter your information to retrieve an existing quote'
          }
        ]
      }
    },
    {
      name: 'Receive a Quote',
      path: '/receive-a-quote',
      component: ReceiveAQuote,
      meta: {
        title: 'Receive a Quote - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Receive a customized quote from Porsche Auto Insurance'
          },
          {
            property: 'og:description',
            content: 'Receive a customized quote from Porsche Auto Insurance'
          },
          NOINDEX
        ]
      }
    },
    {
      name: 'Connect',
      path: '/connect/:id',
      component: Connect,
      props: route => ({
        token: route.params.id,
        source: route.query && route.query.source
      }),
      meta: {
        suppressMainNavigation: true,
        title: 'Receive a Quote - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'Receive a customized quote from Porsche Auto Insurance'
          },
          {
            property: 'og:description',
            content: 'Receive a customized quote from Porsche Auto Insurance'
          },
          NOINDEX
        ]
      }
    },
    {
      path: '/receive-a-quote/quote-info-page',
      redirect: '/receive-a-quote'
    },
    {
      path: '/receive-a-quote/quote-vehicles-page',
      redirect: '/receive-a-quote'
    },
    {
      path: '/receive-a-quote/quote-drivers-page',
      redirect: '/receive-a-quote'
    },
    {
      path: '/receive-a-quote/quote-coverage-page',
      redirect: '/receive-a-quote'
    },
    {
      path: '/receive-a-quote/quote-quote-page',
      redirect: '/receive-a-quote'
    },
    {
      path: '/receive-a-quote/quote-payment-page',
      redirect: '/receive-a-quote'
    },
    {
      path: '/receive-a-quote/quote-thank-you-page',
      redirect: '/receive-a-quote'
    },
    {
      name: 'Rollover',
      path: '/rollover',
      component: Rollover,
      props: route => ({
        identifier: route.hash ? route.hash.replace('#', '') : null
      }),
      meta: {
        title: 'Porsche Auto Insurance - Policy Renewal',
        metaTags: [
          {
            name: 'description',
            content: 'Update your account policy'
          },
          {
            property: 'og:description',
            content: 'Update your account policy'
          },
          NOINDEX
        ]
      }
    },
    {
      name: 'Unavailable',
      path: '/unavailable/:state?',
      component: Unavailable,
      props: route => ({
        state: route.query.state
      }),
      meta: {
        suppressMainNavigation: true,
        title: "Let's Stay in Touch! - Porsche Auto Insurance",
        metaTags: [
          {
            name: 'description',
            content:
              'Connect with us by entering your information and we will let you know when Porsche Auto Insurance comes near you.'
          },
          {
            property: 'og:description',
            content:
              'Connect with us by entering your information and we will let you know when Porsche Auto Insurance comes near you.'
          }
        ]
      }
    },
    {
      name: 'Faq',
      path: '/faq',
      component: Faq,
      meta: {
        title: 'FAQ - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'View the most frequently asked questions about Porsche Auto Insurance'
          },
          {
            property: 'og:description',
            content:
              'View the most frequently asked questions about Porsche Auto Insurance'
          }
        ]
      }
    },
    {
      name: 'ContactUs',
      path: '/contact-us',
      component: ContactUs,
      meta: {
        title: 'Contact Us - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'Use this form to contact the Porsche Auto Insurance customer care team'
          },
          {
            property: 'og:description',
            content:
              'Use this form to contact the Porsche Auto Insurance customer care team'
          }
        ]
      }
    },
    {
      name: 'Stay Connected',
      path: '/stay-connected',
      component: StayConnected,
      meta: {
        title: 'Stay Connected - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'Use this form to stay connected with Porsche Auto Insurance updates'
          },
          {
            property: 'og:description',
            content:
              'Use this form to stay connected with Porsche Auto Insurance updates'
          }
        ]
      }
    },
    {
      name: 'PrivacyPolicy',
      path: '/legal/privacy-policy',
      component: PrivacyPolicy,
      meta: {
        title: 'Privacy Policy - Legal - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'View the privacy policy for PorscheAutoInsurance.com'
          },
          {
            property: 'og:description',
            content: 'View the privacy policy for PorscheAutoInsurance.com'
          }
        ]
      }
    },
    {
      name: 'SmsPolicy',
      path: '/legal/sms',
      component: Sms,
      meta: {
        title: 'SMS - Legal - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content:
              'View the SMS/Text Messaging policy for PorscheAutoInsurance.com'
          },
          {
            property: 'og:description',
            content:
              'View the SMS/Text Messaging policy for PorscheAutoInsurance.com'
          }
        ]
      }
    },
    {
      name: 'TermsOfUse',
      path: '/legal/terms-of-use',
      component: TermsOfUse,
      meta: {
        title: 'Terms of Use - Legal - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'View the terms of use for PorscheAutoInsurance.com'
          },
          {
            property: 'og:description',
            content: 'View the terms of use for PorscheAutoInsurance.com'
          }
        ]
      }
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        title: 'Page Not Found - Porsche Auto Insurance',
        metaTags: [
          {
            name: 'description',
            content: 'We are unable to locate that page'
          },
          {
            property: 'og:description',
            content: 'We are unable to locate that page'
          }
        ]
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const scrollOptions = {
        duration: 700,
        offset: -document.getElementsByClassName('header')[0].offsetHeight
      };

      VueScrollTo.scrollTo(to.hash, scrollOptions);

      return {
        selector: to.hash
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

// import { getRoutesXML } from './sitemap-generator';
// console.log(getRoutesXML(router, 'https://www.porscheautoinsurance.com'));

router.beforeEach((to, from, next) => {
  if (to.path === '/rollover' && !to.hash) {
    next('/');
  }
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  window.scrollTo(0, 0);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  Array.from(
    document.querySelectorAll('[data-vue-router-controlled]')
  ).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) {
    return next();
  }

  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));

  if (
    to.matched.some(record => record.meta.requiresAuth) ||
    (to.path === '/receive-a-quote' && to.query.token)
  ) {
    let sessionCheckTimer;
    let checkLoginSession = () => {
      if (sessionCheckTimer) {
        clearInterval(sessionCheckTimer);
      }
      if (to.query.token || store.getters.authStatus === 'loading') {
        next();
      } else {
        if (to.matched.some(record => record.name === 'LogIn')) {
          next('/');
        } else {
          next();
        }
      }
    };
    if (store.getters.authStatus === '') {
      sessionCheckTimer = setInterval(() => {
        if (
          store.getters.authStatus !== '' &&
          store.getters.authStatus !== 'loading'
        ) {
          checkLoginSession();
        }
      }, 100);
    } else {
      checkLoginSession();
    }
  } else {
    next();
  }
});

export default router;
